import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { DEFAULT_SCALE_DOWN_CONFIG } from '@/game/GameComponents/PhaserGame/Types/ManagerTypes/ResponsivenessManagerTypes';
import { getAnchorPlugin } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import { getGameInstructions, getGameName } from '@/game/gameHelpers';
import DefaultButton from '@/game/prefabs/GeneralUI/Buttons/DefaultButton';
import DefaultDenyButton from '@/game/prefabs/GeneralUI/Buttons/DefaultDenyButton';
import MinigameInstructions from '@/game/prefabs/Minigame/MinigameInstructions';

export default class MinigameInstructionsController {
  constructor(private minigameInstructions: MinigameInstructions) {
    this.getResponsiveElements('startMinigameButton').forEach(
      (button: DefaultButton) => {
        button.controller.setSubmissionCallback(() =>
          this.onInstructionsViewSubmitted?.(),
        );
      },
    );

    this.getResponsiveElements('returnToWorldButton').forEach(
      (button: DefaultDenyButton) => {
        button.controller.setSubmissionCallback(() => {
          this.onInstructionsViewCancelled?.();
        });
      },
    );

    this.initializeResponsiveness();
  }

  currentGame: string = '';
  onInstructionsViewSubmitted?: () => void;
  onInstructionsViewCancelled?: () => void;

  getResponsiveElements(key: keyof MinigameInstructions) {
    return ResponsivenessManager.GetAllResponsiveComponentsFromContainer(
      this.minigameInstructions,
      key,
    );
  }

  setGame(game: string) {
    this.currentGame = game;
    // Set title.
    this.getResponsiveElements('gameTitleText').forEach(
      (gameTitleText: Phaser.GameObjects.BitmapText) => {
        gameTitleText.setText(getGameName(game) || '<GAME UNDEFINED>');
      },
    );

    // Set description.
    this.getResponsiveElements('gameDescription').forEach(
      (gameDescription: Phaser.GameObjects.BitmapText) => {
        gameDescription.setText(
          getGameInstructions(game) || '<DESCRIPTION NOT FOUND>',
        );
      },
    );
  }

  initializeResponsiveness() {
    const { minigameInstructions } = this;
    ResponsivenessManager.InitializeResponsiveBreakpoints({
      scene: minigameInstructions.scene,
      desktopView: minigameInstructions.desktopView,
      mobileView: minigameInstructions.mobileView,
    });

    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      minigameInstructions.desktopView,
      DEFAULT_SCALE_DOWN_CONFIG,
    );

    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      minigameInstructions.mobileView,
      DEFAULT_SCALE_DOWN_CONFIG,
    );

    const anchor = getAnchorPlugin(minigameInstructions.scene);
    anchor.add(minigameInstructions, {
      centerX: '50%',
      centerY: '50%',
    });
  }
}
